import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import BrandIntro from './components/BrandIntro';
import Reputation from './components/Reputation';
import ContactSection from './components/ContactSection';

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '安全指南',
  url: 'https://yourdomain.com/',
  description: '专注于网络安全与合规知识的教育平台',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@safety-guide.example.com',
    contactType: 'customer service',
    availableLanguage: '中文',
  },
};

const aboutPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于安全指南',
  description: '了解安全指南的品牌故事、团队背景、核心价值观及联系方式',
  url: 'https://yourdomain.com/about',
  mainEntity: {
    '@type': 'Organization',
    name: '安全指南',
    description: '专注于网络安全与合规知识的教育平台',
  },
};

export default function AboutPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutPageSchema) }}
      />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6 pt-6">
          <Breadcrumb
            items={[
              { name: '首页', path: '/' },
              { name: '关于我们' },
            ]}
          />
          <BrandIntro />
        </div>
        <Reputation />
        <div className="max-w-7xl mx-auto">
          <ContactSection />
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}